import React, { forwardRef, useEffect, useState } from "react";
import logo from "../../assets/img/adn-logo.png";
import Modal from "../ui/Modal";
import { useNavigate } from "react-router-dom";
import CrossIcon from "../../assets/icons/cross";
import { useHeaderContext } from "../../context/HeaderContext";
import { getProcurements } from "../../services/api/procurementService";
import { useUserContext } from "../../context/userContext";
import NotificationsIcon from '@mui/icons-material/Notifications';
import { Badge, badgeClasses, IconButton, styled } from "@mui/material";
import LogoutIcon from '@mui/icons-material/Logout';

const Header = forwardRef(function Header(props, ref) {
  const { user } = useUserContext();
  const navigate = useNavigate();
  const { setHeaderHeight, headerAlert, setHeaderAlert } = useHeaderContext();
  const [notifications, setNotifications] = useState(0);
  const [isNotificationModalOpen, setIsNotifcationsModalOpen] = useState(false);

  const NotificationBadge = styled(Badge)`
  & .${badgeClasses.badge} {
    top: -12px;
    right: 0px;
  }
`;

  const signOut = async () => {
    try {
      window.sessionStorage.clear();
    } catch (e) {
      console.error("Erreur lors de la déconnexion :", e);
    } finally {
      window.sessionStorage.clear();
      localStorage.clear();
      window.location.href = "/login";
    }
  };

  useEffect(() => {
    if (ref && ref.current) {
      setHeaderHeight(ref.current.offsetHeight);
    }
  }, [headerAlert, ref, setHeaderHeight]);

  useEffect(() => {
    async function fetchProcurements() {
      try {
        const result = await getProcurements();
        const procurements = Array.isArray(result) ? result : [];
        setNotifications(procurements.filter(procurement => procurement.isUserAction).length);
      } catch (error) {
        console.error('Erreur lors de la récupération des procurements:', error);
        setNotifications(0);
      }
    }

    if (user) {
      fetchProcurements();
    }
  }, [user]);

  const handleMouseDown = (event) => {
    if (event.button === 1) {
      window.open("/", '_blank');
    } else if (event.button === 0) {
      navigate("/");
    }
  };

  return (
    <>
      <header ref={ref} className="absolute top-0 w-full z-40">
        <div className="flex flex-wrap justify-between items-center mx-auto bg-sky-300 border-gray-200 px-4 py-2.5 h-24 relative">

          <div className="flex flex-row h-full items-center cursor-pointer" onMouseDown={handleMouseDown}>
            <img src={logo} className="h-full" alt="Logo Agence du Numérique" />
          </div>

          <div className="flex gap-6 items-center">
            {notifications > 0 && (
              <IconButton
                onClick={() => setIsNotifcationsModalOpen(true)}
              >
                <NotificationsIcon fontSize="large" />
                <NotificationBadge badgeContent={notifications} color="info" overlap="circular" />
              </IconButton>
            )}

            <span className="font-medium focus:outline-none hidden sm:block">{user?.fullname}</span>

            <IconButton color="error" onClick={signOut}>
              <LogoutIcon />
            </IconButton>

          </div>
        </div>

        {headerAlert
          && (
            <div className="flex justify-between items-center mx-auto bg-yellow-200 border-gray-200 py-2 px-6">
              <div>
                ⚠️ Attention : La création et les modifications de marchés sont temporairement suspendues. Merci de votre compréhension.
              </div>
              <button className="w-7 h-auto rounded-md bg-gray-300 p-0.5" onClick={() => setHeaderAlert(false)}>
                <CrossIcon />
              </button>
            </div>
          )}

      </header>

      {isNotificationModalOpen && (
        <Modal
          title="Marché(s) public(s) en attente"
          onClose={() => setIsNotifcationsModalOpen(false)}
        >
          <div className="p-10">
            Il y a <span className="font-semibold">{notifications}</span> marchés publics en attente d'une action de votre part.
          </div>
        </Modal>
      )}
    </>
  );
});

export default Header;
